<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-协议-添加
    -->
  <div>
    <el-dialog
    title="添加协议"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
      <div class="common-form">添加协议</div>
      <el-form-item label="协议名称" prop="name"><el-input v-model="form.name" placeholder="请输入协议名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="协议分类" prop="category">
        <el-select v-model="form.category" placeholder="请选择协议分类" style="width: 300px;">
          <el-option label="安全承诺书" value="1"></el-option>
          <el-option label="安全责任书" value="2"></el-option>
          <el-option label="安全告知书" value="3"></el-option>
          <el-option label="其他文件签订" value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所属组织" prop="organization">
        <el-select v-model="form.organization" placeholder="请选择所属组织" clearable filterable style="width: 300px;">
          <el-option v-for="item in organizationList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="接收人" prop="receiver_ids">
        <div style="width: 100%;">
          <div v-if="selectedEmployees.length > 0" class="selected-employees">
            <el-tag
              v-for="emp in selectedEmployees"
              :key="emp.ma_yg_id"
              closable
              @close="removeEmployee(emp.ma_yg_id)"
              style="margin-right: 10px; margin-bottom: 10px;"
            >
              {{ emp.name }}
            </el-tag>
          </div>
          <el-button size="small" icon="el-icon-plus" @click="openSelectEmployee">选择接收人</el-button>
        </div>
      </el-form-item>

      <el-form-item v-if="form.category === '2' || form.category === '4'" label="签订主体" prop="signing_entity">
        <el-radio-group v-model="form.signing_entity">
          <el-radio label="1">部门</el-radio>
          <el-radio label="2">公司</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="form.category === '2'" label="有效开始日期" prop="effective_start_date">
        <el-date-picker
          v-model="form.effective_start_date"
          type="date"
          placeholder="选择有效开始日期"
          value-format="yyyy-MM-dd"
          style="width: 300px;">
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="form.category === '2'" label="有效截止日期" prop="effective_end_date">
        <el-date-picker
          v-model="form.effective_end_date"
          type="date"
          placeholder="选择有效截止日期"
          value-format="yyyy-MM-dd"
          style="width: 300px;">
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="form.category !== '2'" label="到期时间" prop="expire_time">
        <div style="display: flex; align-items: center;">
          <el-date-picker
            v-model="form.expire_time"
            type="datetime"
            placeholder="选择到期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 300px;"
            :disabled="form.is_long_term">
          </el-date-picker>
          <el-checkbox v-model="form.is_long_term" style="margin-left: 20px;">长期有效</el-checkbox>
        </div>
      </el-form-item>

      <el-form-item label="说明" prop="description">
        <el-input type="textarea" v-model="form.description" :rows="3" placeholder="请输入说明" style="width: 500px;"></el-input>
      </el-form-item>

      <el-form-item label="简介" prop="summary">
        <el-input type="textarea" v-model="form.summary" :rows="3" placeholder="请输入简介" style="width: 500px;"></el-input>
      </el-form-item>

      <el-form-item label="附件" prop="attachments">
        <div class="attachment-list">
          <div v-if="form.attachments && form.attachments.length > 0">
            <div v-for="(item, index) in form.attachments" :key="index" class="attachment-item">
              <i class="el-icon-document attachment-icon"></i>
              <span class="attachment-name">{{ item.name }}</span>
              <i class="el-icon-close attachment-close" @click="removeAttachment(index)"></i>
            </div>
          </div>
          <el-button size="small" icon="el-icon-plus" @click="openAttachmentUpload">上传附件</el-button>
        </div>
      </el-form-item>

      <el-form-item label="协议" prop="content">
        <div class="edit_container">
          <Uediter v-model="form.content" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>

      <el-form-item prop="agree_terms" style="margin-left: 0;">
        <el-checkbox v-model="form.agree_terms">
          <span style="display: inline-block; width: 100%; word-wrap: break-word; word-break: break-all; line-height: 1.5;">注意:您发布的内容必须符合法律法规和道德标准，不得包含任何违法、违规、不道德、不健康或具有误导性的信息</span>
        </el-checkbox>
      </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>

<SelectEmployee :visible.sync="selectEmployeeVisible" :selected-ids="form.receiver_ids" @confirm="handleSelectEmployee"></SelectEmployee>
<Upload v-if="isAttachmentUpload" :config="{ total: 10 }" :isupload="isAttachmentUpload" @returnImgs="returnAttachmentImgsFunc">上传附件</Upload>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Uediter from '@/components/UE.vue';
import SelectEmployee from './SelectEmployee.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*编辑器*/
    Uediter,
    SelectEmployee,
    Upload
  },
  data() {
    return {
            /*富文本配置*/
            ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        category: '',
        organization: '',
        receiver_ids: [],
        signing_entity: '',
        effective_start_date: '',
        effective_end_date: '',
        expire_time: '',
        is_long_term: false,
        agree_terms: false,
        description: '',
        summary: '',
        attachments: [],
        content: '',
      },
      loading: false,
      /*组织列表*/
      organizationList: [],
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入协议名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择协议分类', trigger: 'change' }],
        agree_terms: [{ required: true, message: '请勾选同意条款', trigger: 'change' }],
      },
      dialogVisible:false,
      /*已选择的员工*/
      selectedEmployees: [],
      /*选择员工弹窗显示*/
      selectEmployeeVisible: false,
      /*附件上传显示*/
      isAttachmentUpload: false,
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getOrganizationList();
  },
  props: ["open_add"],
  methods: {
    /*获取组织列表*/
    getOrganizationList() {
      let self = this;
      let Params = {
        page: 1,
        list_rows: 1000
      };
      AfuncApi.call({
        model: 'ma_company',
        action: 'getList',
        ...Params
      })
        .then(data => {
          self.organizationList = data.data.list.data || [];
        })
        .catch(error => {
        });
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    /*打开选择员工弹窗*/
    openSelectEmployee() {
      this.selectEmployeeVisible = true;
    },

    /*处理选择员工*/
    handleSelectEmployee(employees) {
      this.selectedEmployees = employees;
      this.form.receiver_ids = employees.map(emp => emp.ma_yg_id);
    },

    /*移除员工*/
    removeEmployee(employeeId) {
      this.selectedEmployees = this.selectedEmployees.filter(emp => emp.ma_yg_id !== employeeId);
      this.form.receiver_ids = this.form.receiver_ids.filter(id => id !== employeeId);
    },

    /*打开附件上传*/
    openAttachmentUpload() {
      this.isAttachmentUpload = true;
    },

    /*上传附件*/
    returnAttachmentImgsFunc(e) {
      if (e != null) {
        let allowedExts = ["docx", "doc", "pdf"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          allowedExts.forEach((allowedExt) => {
            if (ext === allowedExt) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("附件类型有误，只能上传 .docx, .doc, .pdf 文件");
          return false;
        }

        let attachments = this.form.attachments.concat(e);
        this.$set(this.form, "attachments", attachments);
      }
      this.isAttachmentUpload = false;
    },

    /*移除附件*/
    removeAttachment(index) {
      this.form.attachments.splice(index, 1);
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.content = self.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          AfuncApi.call({
            model: 'xieyi',
            action: 'add',
            ...form
          })
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.selected-employees {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.attachment-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.attachment-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.attachment-icon {
  margin-right: 8px;
  color: #409eff;
}

.attachment-name {
  flex: 1;
  color: #606266;
}

.attachment-close {
  cursor: pointer;
  color: #909399;
  margin-left: 8px;
}

.attachment-close:hover {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/xieyi/part/add.vue